import React, { useEffect, useState } from "react";
import "./Send_Msg_Req.css";
import DashboardHeader from "../../../../components/header/DashboardHeader";
import { img_placehlder, Name } from "../../../../assets";

import { CiLocationOn } from "react-icons/ci";
import { MdCalendarMonth, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FaArrowLeft, FaFacebook, FaLink } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { FaXTwitter } from "react-icons/fa6";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { AiOutlineMessage } from "react-icons/ai";
import { Dropdown } from "react-bootstrap";
import Remove_Member from "./Remove_Member";
import {
  chatRequestApi,
  memberProfileApi,
} from "../../../../services/groupMember";
import { toastMessage } from "../../../../utils/toastMessage";
import { formatDateTime } from "../../../../utils/dateTimeFormat";
import { LoadingButton } from "../../../../components/header/form";
import { memberGroupType } from "../../../../utils/staticData";
import { tabHandler } from "../../../../utils/regexValidation";
import CreatedGroup from "../memberGroup/CreatedGroup";
import JoinedGroup from "../memberGroup/JoinedGroup";
import OverviewReport from "../../Overview/section/OverviewReport";

const Send_Msg_Req = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const groupType = searchParam.get("groupType") || "created";
  const { memberId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [memberProfile, setMemberProfile] = useState({});
  const [RemovememberModal, setRemovememberModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);

  // Fetching Member Detail
  const fetchMemberDetail = async () => {
    try {
      const { data } = await memberProfileApi(memberId);
      const { success, message, data: response } = data;

      if (success) {
        setMemberProfile(response);
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  // Send Request To Other Users
  const sendChatRequestHandler = async () => {
    try {
      setLoading(true);
      const { data } = await chatRequestApi({ _user: memberId });
      const { success, message } = data;
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
      if (success) {
        fetchMemberDetail();
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMemberDetail();
  }, []);

  return (
    <>
      <DashboardHeader title={"Groups"} />

      <div className="dashboard_pages">
        <div className="send_msg_req_parent">
          <div className="send_msg_req_wrap">
            <div className="breadcrumb_wrap">
              <ul>
                <li className="has_arrow">
                  <Link to={-1}>
                    <FaArrowLeft className="backarrow_grp_detail" />
                  </Link>
                </li>
                <li>Profile Details</li>
              </ul>
            </div>

            <div className="profile_details_wraper">
              <div className="profile_dp">
                <img
                  src={memberProfile?.profilePicture || img_placehlder}
                  alt="Name"
                />

                <div className="profile_details">
                  <div className="profile_name">
                    <h3>
                      {memberProfile?.fullName || "---"}
                      <span className="nickname">
                        {memberProfile?.nickname &&
                          `(${memberProfile?.nickname || ""})`}
                      </span>
                    </h3>
                  </div>
                  <div className="job_role mb-1">
                    <span>{memberProfile?.profession || ""}</span>
                  </div>
                  <div className="button_wrap">
                    <LoadingButton
                      type="button"
                      isDisabled={
                        memberProfile?.chatRequests?.status &&
                        memberProfile?.chatRequests?.status !== "ACCEPTED"
                      }
                      className="msg_req"
                      onClick={() => {
                        const { _id, status } =
                          memberProfile?.chatRequests || {};
                        if (!_id) {
                          sendChatRequestHandler();
                        } else if (_id && status === "ACCEPTED") {
                          navigate(
                            `/dashboard/message/member/${memberProfile?.chatRequests?._chat}/MEMBER`
                          ); //here pass chat id only then navigate
                        }
                      }}
                      loading={loading}
                    >
                      {memberProfile?.chatRequests?._id
                        ? memberProfile?.chatRequests?.status === "ACCEPTED"
                          ? "Chat"
                          : "Chat Invitation Sent"
                        : "Send Message Request"}
                    </LoadingButton>
                    <button type="button" className="more">
                      <Dropdown className="custom_dropdown">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          More...
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            as={Link}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setReportModal(true);
                            }}
                          >
                            Report
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </button> 
                  </div>
                  {/* <button type="button" className="chat_req">
                  <AiOutlineMessage /> chat
                </button> */}
                </div>
              </div>

              <div className="profile_details_rgt">
                <p className="info">Personal information</p>
                <p className="address">
                  <span className="calendar">
                    <MdCalendarMonth className="calendar_icon" />{" "}
                    {formatDateTime(memberProfile?.dateOfBirth, "date")}
                    <span className="location">
                      <CiLocationOn className="location_icon" />{" "}
                      {memberProfile?.address?.state},{" "}
                      {memberProfile?.address?.country}
                    </span>
                  </span>
                </p>

                {memberProfile?.socialMediaLinks &&
                  Object.keys(memberProfile?.socialMediaLinks).length > 0 && (
                    <div className="profile_detail_icon">
                      <div className="social_icon">
                        <Link to={""}></Link>
                        <FaLink className="link" />
                      </div>

                      <div className="social_icon">
                        {memberProfile?.socialMediaLinks?.facebook && (
                          <>
                            <Link
                              to={
                                memberProfile.socialMediaLinks.facebook.startsWith(
                                  "http"
                                )
                                  ? memberProfile.socialMediaLinks.facebook
                                  : `https://${memberProfile.socialMediaLinks.facebook}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            ></Link>
                            <FaFacebook className="facebook" />
                          </>
                        )}
                      </div>
                      <div className="social_icon">
                        {memberProfile?.socialMediaLinks?.instagram && (
                          <>
                            <Link
                              to={
                                memberProfile.socialMediaLinks.instagram.startsWith(
                                  "http"
                                )
                                  ? memberProfile.socialMediaLinks.instagram
                                  : `https://${memberProfile.socialMediaLinks.instagram}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            ></Link>
                            <RiInstagramFill className="insta" />
                          </>
                        )}
                      </div>
                      <div className="social_icon">
                        {/* <Link to={memberProfile?.socialMediaLinks?.x} target="_blank" rel="noopener noreferrer"></Link>
                      <FaXTwitter className="x" /> */}
                        {memberProfile?.socialMediaLinks?.x && (
                          <>
                            <Link
                              to={
                                memberProfile.socialMediaLinks.x.startsWith(
                                  "http"
                                )
                                  ? memberProfile.socialMediaLinks.x
                                  : `https://${memberProfile.socialMediaLinks.x}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            ></Link>
                            <FaXTwitter className="x" />
                          </>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          {/* Tabber */}
          <div className="tabber">
            <ul className="tab_button">
              {memberGroupType?.map((data, ind) => (
                <li
                  key={ind}
                  onClick={() =>
                    tabHandler(
                      "groupType",
                      data?.value,
                      searchParam,
                      setSearchParam
                    )
                  }
                  className={groupType === data?.value ? "active" : ""}
                >
                  {data?.name}
                </li>
              ))}
            </ul>

            <div className="tab_content">
              {groupType === "created" && (
                <CreatedGroup groupType={groupType} memberId={memberId} />
              )}

              {groupType === "joined" && (
                <JoinedGroup groupType={groupType} memberId={memberId} />
              )}
            </div>
          </div>

          {RemovememberModal && (
            <Remove_Member
              RemovememberModal={RemovememberModal}
              setRemovememberModal={setRemovememberModal}
            />
          )}
        </div>
      </div>
      {/* ---------report--------------------- */}
      {/* <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={memberProfile}
        type='GROUP'
      /> */}
      <OverviewReport
        type="USER"
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={null}
        pageName="Member"
        id={memberId}
      />
    </>
  );
};

export default Send_Msg_Req;
